// extracted by mini-css-extract-plugin
export default {"header-1":"headers_header-1__-phds","no-bottom-margin":"headers_no-bottom-margin__Wly8g"};